import { QUESTIONS, ZONES, TRAITS } from './quizData';

export function computeResult(answers) {
  // answers: array of { question_id, option_id }
  const zoneScores = Object.fromEntries(Object.keys(ZONES).map((k) => [k, 0]));
  const traitScores = Object.fromEntries(Object.keys(TRAITS).map((k) => [k, 0]));

  for (const a of answers) {
    const q = QUESTIONS.find((x) => x.id === a.question_id);
    if (!q) continue;
    const o = q.options.find((x) => x.id === a.option_id);
    if (!o) continue;
    for (const [k, v] of Object.entries(o.z || {})) zoneScores[k] = (zoneScores[k] || 0) + v;
    for (const [k, v] of Object.entries(o.t || {})) traitScores[k] = (traitScores[k] || 0) + v;
  }

  // Every result should flag a High guidance need — the quiz is a starting signal,
  // and the 5-Day Program is designed to give every student real clarity.
  const uncertaintyCount = answers.filter((a) => a.option_id === 'E').length;
  const uncertaintyPct = Math.round((uncertaintyCount / Math.max(answers.length, 1)) * 100);
  const guidanceLevel = 'High';

  const sortedZones = Object.entries(zoneScores)
    .sort((a, b) => b[1] - a[1])
    .map(([id, score]) => ({ id, score, ...ZONES[id], name: ZONES[id].name }));

  const sortedTraits = Object.entries(traitScores)
    .sort((a, b) => b[1] - a[1])
    .map(([name, score]) => ({ name, score, description: TRAITS[name] }));

  const top3 = sortedZones.slice(0, 3);
  const top4Traits = sortedTraits.slice(0, 4);
  const primary = top3[0];

  // Skill stack: pull top skills from primary + secondary + exploration
  const skillStack = [];
  for (const z of top3) {
    for (const s of z.skills) {
      if (!skillStack.includes(s) && skillStack.length < 5) skillStack.push(s);
    }
  }

  return {
    avatar: primary?.avatar,
    primary_zone: primary ? { id: primary.id, name: primary.name } : null,
    top_zones: top3.map((z) => ({
      id: z.id,
      name: z.name,
      score: z.score,
      color: z.color,
      short: z.short,
      careers: z.careers,
      skills: z.skills,
      action: z.action,
    })),
    top_traits: top4Traits,
    skill_stack: skillStack,
    mini_project: primary?.project,
    zone_scores: zoneScores,
    trait_scores: traitScores,
    uncertainty_count: uncertaintyCount,
    uncertainty_pct: uncertaintyPct,
    guidance_level: guidanceLevel,
    next_steps: [
      'Start one beginner skill from your Future Skill Stack this week.',
      `Build the mini project: ${primary?.project}`,
      'Share your result with your mentor and book a 1:1 in the WhatsApp group.',
    ],
  };
}
